

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const consultancyApi = createApi({
    reducerPath: 'consultancyApi',
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['Consultancy'],

    endpoints: builder => ({
        getAllMembers: builder.query({
            query: () => `/team_members/all`,
            providesTags: ['Consultancy'],
        }),

        getMemberBySlug: builder.query({
            query: slug => `/team_members/${slug}/`,
            providesTags: ['Consultancy'],
        }),

        createMember: builder.mutation({
            query: formData => ({
                url: `/team_members/create/`,
                method: 'POST',
                body: formData,
            }),
        }),

        updateMember: builder.mutation({
            query: ({ slug, formData }) => ({
                url: `/team_members/partial_update/${slug}/`,
                method: 'PATCH',
                body: formData,
            }),
        }),

        deleteMember: builder.mutation({
            query: slug => ({
                url: `/team_members/delete/${slug}/`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Consultancy'],
        }),
    }),
});

export const {
    useGetAllMembersQuery,
    useGetMemberBySlugQuery,
    useCreateMemberMutation,
    useUpdateMemberMutation,
    useDeleteMemberMutation,
} = consultancyApi;
